/*
  temporaryHashId: creates a 4 character hash [a-z]
*/

export const temporaryHashId = () =>
  [...Array(4).keys()]
    .map(() => {
      const randomLetterIdx = Math.random() * 26;
      return String.fromCharCode(Math.floor(randomLetterIdx + 97));
    })
    .join('');
